export default __webpack_public_path__ + "static/media/logo2.f9a6632c.svg";